export const styleFontColor = {
  txLightweightBlack: '#373D43',
  txLightGrey: '#777A7C',
  borderColorGrey: '#E1E9EF',
};
